<template lang="pug">
label.compact-switch
  input(type="checkbox" :checked="value" :disabled="disabled" @change="$emit('input', $event.target.checked)")
  span.slider
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.compact-switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
}

.compact-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.compact-switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 24px;
}

.compact-switch .slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 19px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

.compact-switch input:checked + .slider {
  background-color: #2196F3;
}

.compact-switch input:checked + .slider:before {
  transform: translateX(21px);
}

.compact-switch input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

.compact-switch input:disabled + .slider {
  background-color: #e0e0e0;
  cursor: not-allowed;
}

.compact-switch input:disabled + .slider:before {
  background-color: #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ToggleSwitch.vue